import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import {
  Dietitian,
  DietitianProps,
} from '../../../../../../data/dietitian/domain/dietitian';
import { DietitianCommands } from '../../../../../../data/dietitian/domain/dietitian_commands';
import {
  DietitianState,
  DietitianStateProvider,
} from '../../../../../../data/dietitian/domain/dietitian_state_provider';
import { SubscriptionCommands } from '../../../../../../data/dietitian/domain/subscription/subscription_commands';
import { DashboardService } from '../../../../dashboard.service';
import { SubscriptionModel } from '../account-subscription/account-subscription.component';
import { environment } from '../../../../../../../environments/environment';

export interface AccountMsdpLinkViewModel {
  isLoading: boolean;
  error: string;
  dietitian: Dietitian;
}

@Injectable()
export class AccountMsdpLinkFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private dietitianCommands: DietitianCommands,
    private subscriptionCommands: SubscriptionCommands,
    private dashboardService: DashboardService,
  ) {
    // Nada
  }

  get dietitianState$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  geLatestSubscription(
    dietitian: Dietitian,
  ): Promise<SubscriptionModel | undefined> {
    return this.subscriptionCommands.getLatestSubscription(dietitian);
  }

  isLinked(dietitian: Dietitian | undefined) {
    return this.dashboardService.isLinked(dietitian);
  }

  async signup(
    dietitian: Dietitian | undefined,
    user: string,
    password: string,
  ) {
    if (dietitian) {
      dietitian = dietitian.copyWith({
        msdpUser: user,
        msdpPassword: crypto.AES.encrypt(
          password,
          environment.monSuiviDietPlus.secret,
        ).toString(),
        msdpKey: uuidv4(),
      } as DietitianProps);
      await this.dashboardService.signup(dietitian);
    }
  }

  async login(
    dietitian: Dietitian | undefined,
    user: string,
    password: string,
  ) {
    if (dietitian) {
      dietitian = dietitian.copyWith({
        msdpUser: user,
        msdpPassword: crypto.AES.encrypt(
          password,
          environment.monSuiviDietPlus.secret,
        ).toString(),
        msdpKey: uuidv4(),
      } as DietitianProps);
      await this.dashboardService.login(dietitian);
    }
  }

  async link(dietitian: Dietitian) {
    return this.dashboardService.link(dietitian);
  }

  async unlink(dietitian: Dietitian) {
    return this.dashboardService.unlink(dietitian);
  }

  updateAccount(dietitianProps: DietitianProps): Promise<Dietitian> {
    return this.dietitianCommands.updateCurrentDietitian(dietitianProps);
  }
}
